import React, { useState, useEffect, useRef } from "react";
import {Row, Container, Col, Form, Button, Modal } from "react-bootstrap";
import LeftIndent from "utils/LeftIndent";
import CustomTooltip from "utils/CustomTooltip";
import SaveChanges from "./SaveChanges";
import DeleteOrgModal from "organization_management/DeleteOrgModal";
import DefaultAvatar from "utils/DefaultAvatar";
import CustomAvatar from "utils/CustomAvatar";
import jsDig from "utils/jsDig";

export default function OrgInfo(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const formSubmitUrl = `/datapulse/organization`;
  let defaultLogo = require("images/organizations/orgLogo.png");
  const [fileName, setFileName] = useState("No File Chosen");
  const inputRef = useRef();
  const [imageURL, setImageURL] = useState(props.logo ? props.logo : `/datapulse${defaultLogo}`);
  let OrgLogo = <img style={{ maxWidth: "101px", maxHeight: "101px", width: "auto", height: "auto" }} src={imageURL} />;
  let upload = require("images/organizations/upload.png");
  upload = <img style={{paddingBottom:"3px", paddingRight:"12px"}} src={`/datapulse${upload}`} />;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({});
  const [deleteLocked, setDeleteLocked] = useState(true);
  const [zIndexFirst, setZIndexFirst] = useState (2500)
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [toggledUsers, setToggledUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(Object.entries(props.org_users).length > 0 ? Object.entries(props.org_users).map((el) => el[1]).filter(item => item.id === props.owner.id)[0].email: [])
  const unSelectedUsers = Object.entries(props.org_users).map((el) => el[1]).filter(item => item.role === "admin").map((user) => user.email)
  const [visibleUsers, setVisibleUsers] = useState([...unSelectedUsers]);
  const [newOwnerId, setNewOwnerId] = useState()

  let caution = require("images/icons/exclaim-triangle.png");
  caution =  <img className="px-4 d-inline-block" src={`/datapulse${caution}`} />
  

  const handleShow2 = () => {
    setShow2(true);
    setZIndexFirst(1000)
  }

  const handleClose2 = () => {
    setShow2(false)
    setZIndexFirst(3001)
  }

    // Update the list of users you can select from to be only unselected ones
    useEffect(() => {
      setVisibleUsers(Object.entries(props.org_users).map((el) => el[1]).filter(item => item.role === "admin" && item.id !== props.owner.id).map((user) => user.email));
    }, [selectedUsers]);
  
    // Update who the new owner should be whenever a new selection is toggled
    useEffect(() => {
      const capturedId = Object.entries(props.org_users).map((el) => el[1]).filter(item => item.email === toggledUsers[0]).map((user) => user.id)[0]
      setNewOwnerId(capturedId)
    }, [toggledUsers]);
  
    const toggleUser = (e) => {
      let userEmail = e.target.getAttribute("data-email");
      let selection = [...toggledUsers];
      if (selection.includes(userEmail)) {
        selection.splice(selection.indexOf(userEmail), 1);
      } 
      else  {
        selection.pop()
        selection.push(userEmail);
      }
      setToggledUsers(selection);
    };
  
    const selectUsers = () => {
      props.setServiceAccount && props.setServiceAccount([...selectedUsers, ...toggledUsers]);
      setSelectedUsers([...selectedUsers, ...toggledUsers]);
      setToggledUsers([]);
      handleClose();
    };
  
    const handleCancel = () => {
      setToggledUsers([]);
      handleClose();
    };
  
    const searchUsers = (e) => {
      let filter = e.target.value.toLowerCase();
      let matchedUsers = [];
     unSelectedUsers.forEach((userEmail) => {
        let user = props.org_users[userEmail];
        // If the user is not subscribed already && their name or email matches input
        if (!selectedUsers.includes(userEmail) && (user.name.toLowerCase().includes(filter) || userEmail.toLowerCase().includes(filter))) {
          matchedUsers.push(userEmail);
        }
      });
      setVisibleUsers(matchedUsers);
    };
  
    const toggledUsersList = toggledUsers.map((userEmail) => {
      let user = props.org_users[userEmail];
      return (
        <span key={user.id} data-email={userEmail} onClick={(e) => toggleUser(e)}>
          {user.name}
          <i style={{ pointerEvents: "none" }} className="fa fa-times"></i>
        </span>
      );
    });

  

  const confirmDelete = (org) => {
    setDeleteTarget(org)
    setShowDeleteModal(true)
  }

  const deleteOrg = (org) => {
    props.handleOrgDelete()
  }


  return (
    <>
      <Form id="organization-info-form" method="post" encType="multipart/form-data" action={formSubmitUrl}>
        <input hidden name="organization_id" value={props.org.id} readOnly />
        <input hidden name="authenticity_token" value={authenticityToken} readOnly />
        <SaveChanges/>
        {/* <LeftIndent> */}
          <Container fluid className="prim-bg">
            <Row className="">
              <Col className="px-md-5 px-0 text-md-left text-center py-4">
                <h3>Organization Information</h3>
              </Col>
            </Row>
            <Row className="px-md-5 px-3 pb-5">
              <Col  className="d-flex flex-column align-items-center sec-bg justify-content-center p-4 org-logo-container">
                  <div className="align-self-center">
                    <h3 className="f18 ">Organization Logo</h3>
                  </div>
                  <div className="pb-3 logo-wrapper">
                    {OrgLogo}
                    <div className="logo-inner">
                      <p onClick={() => inputRef.current.click()} className="plus-sign">+</p>
                    </div>
                    </div>
                  <div className="pb-3">
                    <input
                      style={{ backgroundColor: "#3291C1", display: "none" }}
                      name="organization_logo"
                      className="py-1 m-2"
                      type="file"
                      ref={inputRef}
                      onChange={(e) => {
                        if (e.target.files[0].size > 8000000) {
                          alert("Image must be less than 8MB. Consider use another image or compress this one.");
                        }
                        setImageURL(URL.createObjectURL(e.target.files[0]));
                        setFileName(e.target.files[0].name);
                      }}
                    />
                    <Button className="orgUpload" onClick={() => inputRef.current.click()}>
                      <span>{upload}Upload Image</span>
                    </Button>
                  </div>
                  <div className="pb-2">
                    <h5 className="visby-medium">{fileName}</h5>
                  </div>
                  <div className="px-5">
                    <p style={{ color: "#7B7DA4 " }} className="f10 nunito-regular text-center">
                      Accepted file types: JPG, PNG, SVG 
                      <br />
                      Minimum file dimensions: 100x100px
                      <br />
                      Ideal ratio 1:1
                      <br />
                      Maximum file size: 8 MB
                    </p>
                  </div>
                </Col>
                <Col className="basic-container px-md-4 px-0 py-3 sec-bg ml-5" >
                  <h3 className="f18">Basic Info</h3>
                    <Row>
                      <Col>
                        <div className="pb-2">
                          <span className="f12 visby-bold light-primary ">Organization Name</span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Control
                          size="sm"
                          style={{ width: "340px" }}
                          name="organization_name"
                          maxLength="30"
                          className="mr-2 mb-2"
                            defaultValue={props.org.name}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="pb-2">
                            <span className="f12 visby-bold  light-primary ">Location</span>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Control
                            size="sm"
                            style={{ width: "340px" }}
                            name="organization_location"
                            maxLength="40"
                            defaultValue={props.org.location}
                            className="mr-2 mb-2"
                            placeholder=""
                          />
                        </Col>
                      </Row>
                    <Row>
                      <Col lg={7} xs={12}>
                        <div className="pb-2">
                          <span className="f12 visby-bold light-primary ">Type</span>{" "}
                        </div>
                        <Form.Control className="client-drop" size="sm" as="select" name="organization_type" 
                        defaultValue={props.org.organization_type} 
                        lg={7} xs={12}>
                          <option disabled hidden>
                            Account Type
                          </option>
                          <option value="agency">Agency</option>
                          <option value="business">Business</option>
                        </Form.Control>
                      </Col>
                    </Row>
                    {props.isOwner &&
                      <div>
                    <Row className="pt-4 mb-2">
                      <Col>
                      <p style={{color: "#555"}}className="f14 text-md-left text-center">Owner Actions:</p>
                      </Col>
                    </Row>
                    <Row className="mb-2 text-md-left text-center">
                      <Col>
                      <Button className="orgTransfer" onClick={() => handleShow()}> Transfer Ownership</Button>
                      </Col>
                    </Row>
                    <Row className="text-md-left text-center">
                      <Col>
                      <Button className="orgDelete" onClick={() => confirmDelete(props.org)} disabled={props.isPrimaryOrg}> Delete this organization</Button>
                      </Col>
                    </Row>
                    </div>
                    }
                  </Col>
                  <Col className="description-container px-md-4 py-3 sec-bg px-0">
                    <h3 className="f18">Description</h3>
                      <Row>
                        <Col>
                        <Form.Control as="textarea" 
                          placeholder="Tell us a bit about what your organization does..." 
                          name="organization_description"
                          rows={12}
                          defaultValue={props.org.description}
                        />
                      </Col>
                    </Row>
                  </Col>
              </Row>
              <Modal className="users-select-modal" show={show} onHide={handleClose} style={{ zIndex: zIndexFirst }}>
                  <div className="page-1">
                    <Modal.Header closeButton>
                      <Modal.Title>Select new organization owner</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Col>
                          <div className="user-search">
                            <span className="fa fa-search"></span>
                            <input onChange={(e) => searchUsers(e)} placeholder="Enter a name or email address..." />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <ul className="user-list">
                            {visibleUsers.map((userEmail) => {
                              let user = props.org_users[userEmail];
                              let avatar = <DefaultAvatar dim="32x32" name={user.name} className="avatar" department={user.department} />;
                              if (user.avatar) {
                                avatar = <CustomAvatar src={user.avatar} className="avatar" department={user.department} />;
                              }
                              let toggled = toggledUsers.includes(userEmail) ? "toggled" : undefined;
                              return (
                                <React.Fragment key={user.id}>
                                  <li onClick={(e) => toggleUser(e)} data-email={userEmail} className={toggled}>
                                    <div style={{ pointerEvents: "none" }}>
                                      <div className="d-inline-block m-0">
                                        <div className="position-relative d-inline-block">
                                          {avatar}
                                          <div className="overlay">
                                            <i className="fa fa-check"></i>
                                          </div>
                                        </div>
                                        <b>&nbsp;{user.name}</b>
                                        <span>&nbsp;{userEmail}</span>
                                      </div>
                                    </div>
                                  </li>
                                </React.Fragment>
                              );
                            })}
                          </ul>
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <div className="toggled-users">
                        <p>
                          <b>Transfer ownership to:</b>
                        </p>
                        {toggledUsersList}
                      </div>
                      <div>
                        <Button style={{ backgroundColor: "#A3A3A3" }} onClick={handleCancel}>
                          Cancel
                        </Button>
                        <Button variant="success" disabled={!newOwnerId} onClick={() => handleShow2()}>
                          Transfer Ownership
                        </Button>
                      </div>
                    </Modal.Footer>
                  </div>
             </Modal>
             <Modal className="secondary-modal" show={show2} onHide={handleClose2} style={{ zIndex: 3007 }}>
               <Modal.Header closeButton>
                      <Modal.Title className="text-center">{caution}{"  "}ARE YOU SURE?</Modal.Title>
                    </Modal.Header>
                  <div className="">
                    <Modal.Body>
                      <Row className="pb-4">
                        <Col>
                        <p>By relinquishing ownership you will lose access to ownership features</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                        <Button className="px-5" style={{ backgroundColor: "#A3A3A3" }} onClick={handleClose2}>
                          Cancel
                        </Button>
                        </Col>
                        <Col>
                        <Button className="px-5" variant="warning" onClick={() => props.handleOwnershipTransfer(newOwnerId)}>
                          Confirm
                        </Button>
                        </Col>
                        </Row>
                      </Modal.Body>
                  </div>
             </Modal>
          </Container>
        {/* </LeftIndent> */}
      </Form>
      <DeleteOrgModal 
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        deleteTarget={deleteTarget}
        setDeleteLocked={setDeleteLocked}
        deleteOrg={deleteOrg}
        deleteLocked={deleteLocked}
      />
    </>
  );
}

